var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testcase-template"},[_c('div',{class:[
      ( _obj = {}, _obj['template-img-active'] = _vm.itemActive, _obj ),
      'template-img'
    ],style:(_vm.itemStyle),on:{"click":function($event){$event.stopPropagation();return _vm.setBoard($event)}}},[_c('svg-icon',{staticClass:"svg-background",style:({'color':_vm.curComponent.commonBackground.innerImageColor}),attrs:{"icon-class":_vm.mainIconClass}})],1),_c('span',{staticClass:"demonstration"},[_vm._v(_vm._s(_vm.template.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }